export const ACCOUNT_UPDATE_ASYNC_START = 'ACCOUNT_UPDATE_ASYNC_START';
export const ACCOUNT_UPDATE = 'ACCOUNT_UPDATE';

export const ACCOUNT_FETCH_ASYNC_START = 'ACCOUNT_FETCH_ASYNC_START';
export const ACCOUNT_FETCH = 'ACCOUNT_FETCH';

export const WITHDRAW_SETTLEMENT = 'WITHDRAW_SETTLEMENT';
